import { render, staticRenderFns } from "./futureRisksScoringTab.vue?vue&type=template&id=c2a4a4f0"
import script from "./futureRisksScoringTab.vue?vue&type=script&lang=js"
export * from "./futureRisksScoringTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports